import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UsersService } from '../../services/users.service';
import { Location } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  inputType1 = 'password';
  showHide1 = '../../../../assets/hide.svg';
  isError = false;
  isErrorText = 'email-or-password-is-wrong';

  constructor(
    private router: Router,
    private location: Location,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
  ) {}

  ngOnInit() {
    const user = this.authenticationService.userValue;
    if (user) {
      this.router.navigate(['/dashboard']);
    }
    this.isError = false;
    this.isErrorText = 'email-or-password-is-wrong';
  }

  goToForgotPassword() {
    this.router.navigate(['/forgot-password']);
  }

  goToRegister() {
    this.router.navigate(['/register']);
  }

  showHideField(numri: any) {
    if (numri === 1) {
      if (this.inputType1 === 'password') {
        this.inputType1 = 'text';
        this.showHide1 = '../../../../assets/show.svg';
      } else {
        this.inputType1 = 'password';
        this.showHide1 = '../../../../assets/hide.svg';
      }
    }
  }

  setEmail(event: any) {
    this.email = event.target.value;
  }

  setPassword(event: any) {
    this.password = event.target.value;
  }

  goBack() {
    this.location.back();
  }

  async login() {
    this.isError = false;
    this.isErrorText = 'email-or-password-is-wrong';

    if (this.email.trim() === '' || this.password.trim() === '') {
      this.isError = true;
      return;
    }
    const credentials = {
      email: this.email,
      password: this.password,
    };
    this.usersService.login(credentials).subscribe(
      async (response) => {
        await this.authenticationService.completeAuthentication(response);
        this.email = '';
        this.password = '';
        this.router.navigate(['/dashboard']);
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.isError = true;
        this.isErrorText = 'email-or-password-is-wrong';
      },
    );
  }
}
